import Box from '@mui/material/Box';
import '../../../../styles/tokens.less';

interface StyledSecondaryMenuWrapperProps {
  children: React.ReactNode;
  testId?: string;
}

export const SecondaryMenuWrapper = ({ children, testId }: StyledSecondaryMenuWrapperProps) => {
  return (
    <Box
      sx={(theme) => ({
        position: 'relative',
        overflow: 'visible',
        background: theme.palette.background.paper,
        height: '100%',
        width: '100%',
      })}
      data-testid={testId}
    >
      {children}
    </Box>
  );
};
